import React from 'react'
import { useTranslation } from 'react-i18next'
import "./retailSector.scss"

function RetailSector() {
  const { t } = useTranslation()
  return (
    <div className='container-retail-sector'>
      <div>
        <div className="title-retail-sector">
          <h1>
            {t("examples.retail_sector.crm_policy.title")} <br /> {t("examples.retail_sector.crm_policy.section_text")}
          </h1>
        </div>
        <div className="div-retail-sector">
          <div className="need">
            <h1>{t("examples.retail_sector.crm_policy.needs.title")}</h1>
            <div className='texto-need'>
              <ul>
                <li>
                  <p>{t("examples.retail_sector.crm_policy.needs.section_text")}</p>
                </li>
              </ul>
            </div>
          </div>
          <br />
          <div className="solution">
            <h1>{t("examples.retail_sector.crm_policy.solutions.title")}</h1>
            <div className='texto-solution'>
              <ul>
                <li>
                  <p>{t("examples.retail_sector.crm_policy.solutions.section_text")}</p>
                </li>
              </ul>
            </div>
          </div>
          <br />
          <div className="results">
            <h1>{t("examples.retail_sector.crm_policy.results.title")}</h1>
            <div className='texto-results'>
              <ul>
                <li>
                  <p>{t("examples.retail_sector.crm_policy.results.section_text_1")}</p>
                </li>
                <li>
                  <p>{t("examples.retail_sector.crm_policy.results.section_text_2")}</p>
                </li>
                <li>
                  <p>{t("examples.retail_sector.crm_policy.results.section_text_3")}</p>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <div>
        <div className="title-retail-sector">
          <h1>
            {t("examples.retail_sector.logistics_policy.title")} <br /> {t("examples.retail_sector.logistics_policy.section_text")}
          </h1>
        </div>
        <div className="div-retail-sector">
          <div className="need">
            <h1>{t("examples.retail_sector.logistics_policy.needs.title")}</h1>
            <div className='texto-need'>
              <ul>
                <li>
                  <p>{t("examples.retail_sector.logistics_policy.needs.section_text_1")}</p>
                </li>
                <li>
                  <p>{t("examples.retail_sector.logistics_policy.needs.section_text_2")}</p>
                </li>
              </ul>
            </div>
          </div>
          <br />
          <div className="solution">
            <h1>{t("examples.retail_sector.logistics_policy.solutions.title")}</h1>
            <div className='texto-solution'>
              <ul>
                <li>
                  <p>{t("examples.retail_sector.logistics_policy.solutions.section_text")}</p>
                </li>
              </ul>
            </div>
          </div>
          <br />
          <div className="results">
            <h1>{t("examples.retail_sector.logistics_policy.results.title")}</h1>
            <div className='texto-results'>
              <ul>
                <li>
                  <p>{t("examples.retail_sector.logistics_policy.results.section_text_1")}</p>
                </li>
                <li>
                  <p>{t("examples.retail_sector.logistics_policy.results.section_text_2")}</p>
                </li>
                <li>
                  <p>{t("examples.retail_sector.logistics_policy.results.section_text_3")}</p>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default RetailSector